import { updateSending } from "vendor/application/disptach";
import { CustomRequestManager } from "vendor/infrastructure/custom_requests_manager";
import { CustomRequest } from "vendor/infrastructure/custom_requests";

export class BillingAPI {
    constructor(accountID, token, props, body) {
        this.accountID = accountID;
        this.token = token;
        this.props = props;
        this.body = body;

        this.props.dispatch(updateSending(true));
    }

    async get_billing() {
        let request = new CustomRequestManager("GET", `accounts/${this.accountID}/billings`, null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_products() {
        let request = new CustomRequestManager("GET", "products", null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_order() {
        let request = new CustomRequestManager("GET", `accounts/${this.accountID}/orders/pending`, null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_order_by_id(id) {
        let request = new CustomRequestManager("GET", `accounts/${this.accountID}/orders/${id}`, null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async hubspot(id) {
        let request = new CustomRequestManager("POST", `accounts/${this.accountID}/orders/${id}/hubspot`, JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async delete_order(id) {
        let request = new CustomRequestManager("DELETE", `accounts/${this.accountID}/orders/${id}`, null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async post_order() {
        let request = new CustomRequestManager("POST", `accounts/${this.accountID}/orders`, JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_order(id) {
        let request = new CustomRequestManager("PUT", `accounts/${this.accountID}/orders/${id}`, JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_countries() {
        let request = new CustomRequestManager("GET", "billings/countries", null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async post_billing() {
        let request = new CustomRequestManager("POST", `accounts/${this.accountID}/billings`, JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_billing(id) {
        let request = new CustomRequestManager("PUT", `accounts/${this.accountID}/billings/${id}`, JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_payments_info(id) {
        let request = new CustomRequestManager("GET", `accounts/${this.accountID}/orders/${id}/payments`, null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async post_contract(id) {
        let request = new CustomRequestManager("POST", `accounts/${this.accountID}/orders/${id}/contracts`, null, this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async put_contract(id) {
        let request = new CustomRequestManager("PUT", `accounts/${this.accountID}/orders/${id}/contract`, JSON.stringify({accepted: true}), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async set_professional_trial() {
        let request = new CustomRequest("PUT", `accounts/${this.accountID}`, JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }


    async interest_intetrations() {
        const request = new CustomRequest("POST", `accounts/${this.accountID}/channels/interest`, JSON.stringify(this.body), this.token, this.props );
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

    async get_account() {
        const request = new CustomRequest("GET", `accounts/${this.accountID}`, null, this.token, this.props );
        const req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }

}